import { render, staticRenderFns } from "./EstimateItemForm.vue?vue&type=template&id=4b494fa6"
import script from "./EstimateItemForm.vue?vue&type=script&lang=js"
export * from "./EstimateItemForm.vue?vue&type=script&lang=js"
import style0 from "./EstimateItemForm.vue?vue&type=style&index=0&id=4b494fa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports